module.exports = __webpack_public_path__ + "img/Hand-Luggage-Only-5-1.90003c26.jpeg";